import { MigrateDialogTxOverview } from '../types'
import { Token } from '@/domain/types/Token'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface MigrateTransactionOverviewProps {
  txOverview: MigrateDialogTxOverview
  selectedToken: Token
  showAPY?: boolean
}

function MigrateTransactionOverview({ txOverview }: MigrateTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    return <TransactionOverviewPlaceholder />
  }
  const { apyChange, outcome } = txOverview

  return (
    <TransactionOverview providedBy="sky">
      {apyChange && (
        <TransactionOverview.Row>
          <TransactionOverview.Label>APY</TransactionOverview.Label>
          <TransactionOverview.ApyChange
            currentApy={apyChange.current}
            updatedApy={apyChange.updated}
            currentApyTestId={testIds.dialog.savings.transactionOverview.apyChange.before}
            updatedApyTestId={testIds.dialog.savings.transactionOverview.apyChange.after}
          />
        </TransactionOverview.Row>
      )}
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.TokenAmount
          token={outcome.token}
          amount={outcome.value}
          usdAmount={outcome.usdValue}
          amountDataTestId={testIds.dialog.transactionOverview.outcome}
          usdAmountDataTestId={testIds.dialog.transactionOverview.outcomeUsd}
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  MigrateTransactionOverview as TransactionOverview,
  type MigrateTransactionOverviewProps as TransactionOverviewProps,
}

function TransactionOverviewPlaceholder() {
  return (
    <TransactionOverview providedBy="sky">
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.Generic>-</TransactionOverview.Generic>
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}
